
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/benchmarks",
      function () {
        return require("private-next-pages/projects/benchmarks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/benchmarks"])
      });
    }
  